/**
 * Design tokens — the single source of truth for brand colors.
 * Every gradient, accent, and surface color in the app should come from here
 * so light mode, dark mode, landing, and dashboard stay visually coherent.
 */

export const BRAND = {
  // Indigo → violet identity
  primary: '#4F46E5',
  primaryLight: '#818CF8',
  primaryDark: '#4338CA',
  violet: '#7C3AED',
  violetLight: '#A78BFA',

  gradient: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
  gradientHover: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)',
  gradientText: 'linear-gradient(135deg, #6366F1 0%, #A78BFA 100%)',
  gradientSubtle: 'linear-gradient(135deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.08) 100%)',

  // Deep slate surfaces (landing hero, footer, dark mode)
  ink: '#0B1120',
  slate900: '#0F172A',
  slate800: '#1E293B',
  slate700: '#334155',

  // Status
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
};

export const LIGHT = {
  background: '#F4F6FC',
  backgroundAlt: '#EEF1FA',
  paper: '#FFFFFF',
  textPrimary: '#0F172A',
  textSecondary: 'rgba(15, 23, 42, 0.62)',
  divider: 'rgba(15, 23, 42, 0.08)',
};

export const DARK = {
  background: '#0B1120',
  backgroundAlt: '#0F1729',
  paper: '#111A2E',
  paperElevated: '#16213B',
  textPrimary: '#F1F5F9',
  textSecondary: 'rgba(241, 245, 249, 0.68)',
  divider: 'rgba(148, 163, 184, 0.14)',
};

/** Soft colored shadow for primary CTAs. */
export const BRAND_SHADOW = '0 8px 24px rgba(99, 102, 241, 0.32)';
export const BRAND_SHADOW_HOVER = '0 12px 32px rgba(99, 102, 241, 0.42)';

/** Category accent colors for template gallery chips. */
export const CATEGORY_COLORS = {
  classic: '#64748B',
  modern: '#6366F1',
  professional: '#0EA5E9',
  creative: '#A855F7',
};
